import React from "react";

function FordEventGameTerms() {
  return (
    <main className="min-h-screen bg-gray-50">
      <section className="py-16 text-white bg-fordBlue">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="mb-3 text-xs tracking-[0.12em] uppercase text-white/70">
            Документ
          </div>

          <h1 className="text-3xl font-semibold leading-tight md:text-4xl">
            ОФИЦИАЛНИ ПРАВИЛА ЗА УЧАСТИЕ В ИГРАТА
          </h1>

          <p className="mt-4 text-base md:text-lg text-white/85">
            „Играй и участвай в томбола за награда от Ford!“
          </p>
        </div>
      </section>

      <section className="py-12 pb-20">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="p-6 bg-white shadow-sm rounded-2xl ring-1 ring-black/5 md:p-10 text-[15px] leading-relaxed text-black/85">
            <Section title="РАЗДЕЛ I. ОРГАНИЗАТОР">
              <p>
                <strong>1.</strong> Играта „Играй и участвай в томбола за
                награда от Ford!“ (наричана по-долу „Играта“) се организира и
                провежда от „Мото-Пфое“ ЕООД, със седалище и адрес на
                управление: гр. София, бул. Сливница № 444, наричано по-долу
                „Организатор“.
              </p>
              <p>
                <strong>2.</strong> Играта не е организирана, спонсорирана или
                по друг начин администрирана от Instagram (Meta Platforms Inc.).
              </p>
            </Section>

            <Section title="РАЗДЕЛ II. ПЕРИОД И ТЕРИТОРИЯ">
              <p>
                <strong>3.</strong> Играта се провежда в периода от 00:00 часа
                на 31.07.2026 г. до 24:00 часа на 09.08.2026 г.
              </p>
              <p>
                <strong>4.</strong> Играта се организира и провежда на
                територията на Република България чрез официалната уебстраница
                на Ford Bulgaria:
              </p>
              <p>
                <a
                  href="https://sale.ford.bg/landing/ford-event-game-test-drive#registration"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://sale.ford.bg/landing/ford-event-game-test-drive#registration
                </a>
              </p>
            </Section>

            <Section title="РАЗДЕЛ III. ПРАВО НА УЧАСТИЕ">
              <p>
                <strong>5.</strong> Право на участие има всяко физическо лице,
                навършило 18 години към датата на стартиране на Играта и имащо
                постоянно или обичайно пребиваване в Република България.
              </p>
              <p>
                <strong>6.</strong> Нямат право на участие служители на
                Организатора, както и служители на рекламни агенции и други
                партньори, участващи в организацията на Играта, както и
                членовете на техните семейства (съпрузи и деца).
              </p>
              <p>
                <strong>7.</strong> Участието в Играта не е обвързано с покупка
                на стоки или услуги.
              </p>
              <p>
                <strong>8.</strong> С извършване на действие по участие,
                участникът декларира, че е запознат и приема настоящите правила.
              </p>
            </Section>

            <Section title="РАЗДЕЛ IV. МЕХАНИЗЪМ НА ИГРАТА">
              <p>
                <strong>9.</strong> Играта се провежда на уебстраницата на Ford
                Bulgaria.
              </p>
              <p>
                <strong>10.</strong> За да участва в томболата, лицето трябва:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  да направи регистрация на уебстраницата на Ford Bulgaria;
                </li>
                <li>
                  за двоен шанс за спечелване на награда да качи стори във
                  Facebook/Instagram и да отбележи Ford Bulgaria -{" "}
                  <a
                    href="https://www.facebook.com/FordBG"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                  >
                    https://www.facebook.com/FordBG
                  </a>{" "}
                  или{" "}
                  <a
                    href="https://www.instagram.com/fordbulgaria"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                  >
                    https://www.instagram.com/fordbulgaria
                  </a>
                  .
                </li>
              </ul>
              <p>
                <strong>11.</strong> Всеки регистрирал се участник получава едно
                участие, а при изпълнение на условията по т. 10 – второ участие.
                Независимо от броя на публикациите, един участник може да получи
                не повече от две участия.
              </p>
              <p>
                <strong>12.</strong> Забранено е:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>използване на автоматизирани средства за участие;</li>
                <li>
                  съдържание, противоречащо на закона, добрите нрави или
                  етичните правила на Национален съвет за саморегулация;
                </li>
                <li>
                  съдържание, което представлява скрита реклама или нарушава
                  права на трети лица.
                </li>
              </ul>
              <p>
                <strong>12а.</strong> Организаторът проверява изпълнението на
                условията за второ участие въз основа на посоченото при
                регистрацията потребителско име и наличната към момента на
                проверката публикация (Story). При невъзможност да бъде
                установено изпълнението на условията, участникът участва само с
                едно участие, получено чрез регистрацията.
              </p>
              <p>
                <strong>13.</strong> Организаторът има право да дисквалифицира
                участник при установено нарушение, като упражнява това право
                добросъвестно и при спазване на приложимото законодателство.
              </p>
            </Section>

            <Section title="РАЗДЕЛ V. НАГРАДА И ТЕГЛЕНЕ">
              <p>
                <strong>14.</strong> Наградите в Играта са три – уикенд тест
                драйв с автомобил Ford по избор, тениска и шапка.
              </p>
              <p>
                <strong>15.</strong> Трима печеливши ще бъдат изтеглени в срок
                до 3 работни дни след приключване на събитието на случаен
                принцип чрез електронен софтуер, в присъствието на комисия от
                трима представители на Организатора. За тегленето се съставя
                протокол.
              </p>
              <p>
                <strong>16.</strong> Организаторът уведомява печелившите чрез
                телефон, електронна поща или лично съобщение в социалната мрежа,
                в зависимост от предоставените данни за контакт, в срок до пет
                работни дни от датата на тегленето.
              </p>
              <p>
                <strong>17.</strong> Ако печелившият не бъде открит или не
                потвърди приемането на наградата в срок от два работни дни от
                първия опит за осъществяване на контакт, той губи правото си
                върху наградата. В този случай Организаторът предоставя
                наградата на първия резервен печеливш, а при необходимост – на
                следващия резервен печеливш.
              </p>
              <p>
                <strong>18.</strong> Наградата не може да бъде заменяна срещу
                паричната ѝ равностойност или друга вещ.
              </p>
              <p>
                <strong>18а.</strong> Наградата следва да бъде получена в срок
                до 30 календарни дни от уведомяването на печелившия, освен ако
                страните не уговорят друго. След изтичането на този срок
                Организаторът не дължи предоставяне на наградата.
              </p>
              <p>
                <strong>19.</strong> В случай че стойността на наградата подлежи
                на облагане съгласно Закон за данъците върху доходите на
                физическите лица, дължимият данък се поема и декларира от
                Организатора.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VI. ОГРАНИЧАВАНЕ НА ОТГОВОРНОСТТА">
              <p>
                <strong>21.</strong> Организаторът не носи отговорност за:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>технически проблеми в платформата Instagram;</li>
                <li>загуба на данни поради хакерски атаки;</li>
                <li>обстоятелства на непреодолима сила.</li>
              </ul>
              <p>
                <strong>22.</strong> Организаторът не носи отговорност за
                претенции за награди, предявени след изтичане на срока по т. 17.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VII. ПРЕКРАТЯВАНЕ НА ИГРАТА">
              <p>
                <strong>23.</strong> Организаторът има право да прекрати, отложи
                или измени Играта при възникване на форсмажорни обстоятелства,
                технически проблеми, злоупотреби или други независещи от него
                причини, които възпрепятстват нормалното провеждане на Играта.
                За това Организаторът уведомява участниците чрез официалните
                комуникационни канали на Ford Bulgaria.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VIII. ЗАЩИТА НА ЛИЧНИТЕ ДАННИ">
              <p>
                <strong>24.</strong> Организаторът обработва лични данни в
                качеството си на администратор съгласно Регламент (ЕС) 2016/679
                и Закон за защита на личните данни.
              </p>
              <p>
                <strong>25.</strong> Обработваните данни могат да включват:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>потребителско име в Instagram;</li>
                <li>три имена;</li>
                <li>телефон и/или имейл за контакт (само за печелившите).</li>
              </ul>
              <p>
                <strong>26.</strong> Личните данни се обработват:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  на основание чл. 6, пар. 1, б. „б“ от Регламент (ЕС) 2016/679
                  – за организиране и провеждане на Играта;
                </li>
                <li>
                  на основание чл. 6, пар. 1, б. „в“ от Регламент (ЕС) 2016/679
                  – за изпълнение на законови задължения, включително по
                  данъчното законодателство, когато е приложимо;
                </li>
                <li>
                  на основание чл. 6, пар. 1, б. „е“ от Регламент (ЕС) 2016/679
                  – за защита на легитимните интереси на Организатора, свързани
                  с предотвратяване на измами и защита при евентуални правни
                  претенции.
                </li>
              </ul>
              <p>
                <strong>27.</strong> Данните се съхраняват за срока на Играта и
                до 3 месеца след нейното приключване, освен ако закон изисква
                по-дълъг срок.
              </p>
              <p>
                <strong>28.</strong> Подробна информация относно обработването
                на личните данни е публикувана в Политиката за поверителност на
                Организатора, достъпна на интернет страницата на Мото-Пфое.
                Всеки участник има право:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>на достъп до данните си;</li>
                <li>на коригиране;</li>
                <li>на изтриване;</li>
                <li>на ограничаване на обработването;</li>
                <li>на жалба до Комисията за защита на личните данни.</li>
              </ul>
              <p>
                <strong>29.</strong> Искания могат да се изпращат на{" "}
                <a
                  href="mailto:privacy@motopfohe.bg"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  privacy@motopfohe.bg
                </a>
                .
              </p>
            </Section>

            <Section title="РАЗДЕЛ IX. ДРУГИ РАЗПОРЕДБИ">
              <p>
                <strong>30.</strong> Организаторът има право да изменя
                правилата, като измененията влизат в сила от момента на
                публикуването им, освен ако промяната засяга вече придобити
                права на участниците.
              </p>
              <p>
                <strong>31.</strong> За всички неуредени въпроси се прилага
                действащото българско законодателство.
              </p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-12">
      <h2 className="mb-5 text-lg font-semibold md:text-xl text-[#0b1f33]">
        {title}
      </h2>
      <div className="grid gap-3.5">{children}</div>
    </div>
  );
}

export default FordEventGameTerms;
